// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"f7ae5789","686":"4f3c3067","858":"048947d4"}[chunkId] + ".chunk.js";
};